module.exports = __webpack_public_path__ + "static/media/right_middle_triangle.dedb9d9e.png";